/* eslint-disable react/prop-types */
import { Share } from '@mui/icons-material';
import { Button } from '@mui/material';
import useWatermark from 'helpers/hook';
import html2canvas from 'html2canvas';
import { PNG } from 'icons/PNG';
import React from 'react';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import Metimur from './logo-metimur-negro.jpg';

export const Download = ({ itemRef, name }) => {
  const { state } = useLocation();
  const watermark = useWatermark(state);

  const handleCapture = async () => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    if (!itemRef.current) {
      Toast.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo encontrar el elemento para descargar.',
      });
      return;
    }

    Toast.fire({
      icon: 'info',
      title: 'Descargando...',
      text: 'Por favor espere',
    });

    try {
      // Captura la imagen del elemento
      const originalCanvas = await html2canvas(itemRef.current, {
        scale: 2,
        useCORS: true,
      });

      // Crear un nuevo canvas con las mismas dimensiones
      const newCanvas = document.createElement('canvas');
      newCanvas.width = originalCanvas.width;
      newCanvas.height = originalCanvas.height;
      const ctx = newCanvas.getContext('2d');

      // Dibujar la imagen capturada en el nuevo canvas
      ctx.drawImage(originalCanvas, 0, 0);

      // Agregar marca de agua
      const watermarkText1 = 'METIMUR';
      const watermarkText2 = ` - ${watermark}`;
      ctx.font = 'bold 24px Arial'; // Fuente más grande y en negrita
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';

      const MetimurLogo = new Image();
      MetimurLogo.src = Metimur; // Asegúrate de que la imagen está accesible en esta ruta

      await new Promise((resolve, reject) => {
        MetimurLogo.onload = () => {
          const logoWidth = 180; // Ajusta según sea necesario
          const logoHeight = 50;
          const padding = 10; // Margen respecto al borde superior derecho

          ctx.drawImage(
            MetimurLogo,
            newCanvas.width - logoWidth - padding, // Alineado a la derecha con margen
            padding, // Margen desde la parte superior
            logoWidth,
            logoHeight
          );
          resolve();
        };
        MetimurLogo.onerror = reject;
      });
      // Dibujar "Metimur" en morado
      ctx.fillStyle = 'rgba(132, 0, 255, 0.5)'; // Morado con menos transparencia
      ctx.fillText(watermarkText1, 50, 20);

      // Medir el ancho del texto "Metimur" para posicionar "watermark"
      const textWidth = ctx.measureText(watermarkText1).width;

      // Dibujar "watermark" en azul
      ctx.fillStyle = '#00AFEF'; // Azul con menos transparencia
      ctx.fillText(watermarkText2, 50 + textWidth, 20);

      // Convertir el nuevo canvas a Blob y descargar
      newCanvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${name.toLowerCase().split(' ').join('-')}.png`;
        a.click();
        URL.revokeObjectURL(url);

        Toast.fire({
          icon: 'success',
          title: 'Descarga completa',
          text: 'Se ha descargado correctamente la gráfica',
        });
      });
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo descargar la gráfica',
      });
      console.error(error);
    }
  };

  return (
    <Button
      onClick={handleCapture}
      variant="contained"
      color="secondary"
      size="small"
      sx={{
        color: 'white',
        fontWeight: 'bold',
        p: 0.5,
        minWidth: '0',
        borderRadius: '50%',
        fontSize: 1,
        width: '35px',
        height: '35px',
      }}
    >
      <PNG />
    </Button>
  );
};

export const ShareButton = ({ itemRef, name }) => {
  const { state } = useLocation();
  const watermark = useWatermark(state);

  const handleShare = async () => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    Toast.fire({
      icon: 'info',
      title: 'Compartiendo Archivo...',
      text: 'Por favor espere',
    });

    if (!itemRef.current) {
      Toast.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo encontrar el elemento para compartir.',
      });
      return;
    }

    try {
      // Captura la imagen del elemento
      const originalCanvas = await html2canvas(itemRef.current, {
        scale: 2,
        useCORS: true,
      });

      // Crear un nuevo canvas con las mismas dimensiones
      const newCanvas = document.createElement('canvas');
      newCanvas.width = originalCanvas.width;
      newCanvas.height = originalCanvas.height;
      const ctx = newCanvas.getContext('2d');

      // Dibujar la imagen capturada en el nuevo canvas
      ctx.drawImage(originalCanvas, 0, 0);

      // Agregar marca de agua
      const watermarkText1 = 'METIMUR';
      const watermarkText2 = ` - ${watermark}`;
      ctx.font = 'bold 24px Arial'; // Fuente más grande y en negrita
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';

      // Dibujar "Metimur" en morado
      ctx.fillStyle = 'rgba(132, 0, 255, 0.5)'; // Morado con menos transparencia
      ctx.fillText(watermarkText1, 50, 20);

      // Medir el ancho del texto "Metimur" para posicionar "watermark"
      const textWidth = ctx.measureText(watermarkText1).width;

      // Dibujar "watermark" en azul
      ctx.fillStyle = '#00AFEF'; // Azul con menos transparencia
      ctx.fillText(watermarkText2, 50 + textWidth, 20);

      // Convertir el nuevo canvas a Blob
      newCanvas.toBlob(async (blob) => {
        const file = new File(
          [blob],
          `${name.toLowerCase().split(' ').join('-')}.png`,
          { type: 'image/png' }
        );

        if (
          navigator.share &&
          navigator.canShare &&
          navigator.canShare({ files: [file] })
        ) {
          await navigator.share({
            title: name,
            text: 'Compartiendo una imagen desde Metimur',
            files: [file],
          });

          Toast.fire({
            icon: 'success',
            title: 'Compartido con éxito',
            text: 'Se ha compartido correctamente la gráfica',
          });

          return;
        }

        // Fallback si no se puede compartir
        Toast.fire({
          icon: 'error',
          title: 'No compatible',
          text: 'Tu navegador no admite compartir archivos',
        });
      }, 'image/png');
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: 'No compatible',
        text: 'Tu navegador no admite compartir archivos',
      });
      console.log(error);
    }
  };

  return (
    <Button
      onClick={handleShare}
      variant="contained"
      color="secondary"
      size="small"
      sx={{
        color: 'white',
        fontWeight: 'bold',
        p: 0.5,
        minWidth: '0',
        borderRadius: '50%',
        maxHeight: '35px',
      }}
    >
      <Share />
    </Button>
  );
};
